import APIClient from './index';
import _ from 'lodash';

export const fetchLatestStyleAudit = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('Admin/style_audit')
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
